srcPath